import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output
} from '@angular/core';
import { Subject } from 'rxjs';
import { StringHelper } from 'src/app/helpers/string-helper';
import { BoardTypeChoices } from 'src/app/model/product/board/board-part';
import IPBoard from 'src/app/model/product/ip-board/ip-board';
import IPBoardPart from 'src/app/model/product/ip-board/ip-board-part';
import { IPBoardPartAbbreviation } from 'src/app/model/product/ip-board/ip-board-part-abbreviation';
import {
  ModalService,
  ObservableHandlerPair
} from 'src/app/services/modal.service';
import {
  ProjectDisplayObservableService,
  SignSelectedEvent
} from 'src/app/services/project-display-observable.service';
import { SubscriptionBasedComponent } from 'src/app/subscription-helpers/subscription-based.component';
import { IPBoardPartAbbreviationSelectorComponent } from './ip-board-part-abbreviation-selector/ip-board-part-abbreviation-selector.component';

@Component({
  selector: 'ip-board-text-input',
  templateUrl: './ip-board-text-input.component.html',
  styleUrls: ['./ip-board-text-input.component.scss']
})
export class IPBoardTextInputComponent extends SubscriptionBasedComponent
  implements OnInit, OnDestroy {
  @Input()
  ipBoard: IPBoard;

  @Input()
  ipBoardPart: IPBoardPart;

  @Input()
  label = 'Links';

  @Output()
  save = new EventEmitter<any>();

  showOtherSideField: boolean = false;

  BOARD_TYPE_CHOICES = BoardTypeChoices;

  private emitTextFilled = new Subject<any>();

  textLabel: string;

  constructor(
    private projectDisplayObservableService: ProjectDisplayObservableService,
    private modalService: ModalService
  ) {
    super();
  }

  ngOnInit(): void {
    this.initializeTextLabel();
    this.initializeShowOtherSideField();
    this.initializeSubscriptions();
  }

  private initializeSubscriptions(): void {
    this.addSubscription(
      this.emitTextFilled,
      () => {
        this.doEmitTextFilled();
      },
      () => {},
      500
    );

    this.addSubscription(
      this.projectDisplayObservableService.getSignSelectedSubscribable(),
      (event: SignSelectedEvent) => {
        if (
          (this.ipBoardPart.id != null &&
            this.ipBoardPart.id === event.ipBoardPart.id) ||
          this.ipBoardPart === event.ipBoardPart
        ) {
          this.initializeTextLabel();
        }
      }
    );
  }

  private initializeTextLabel(): void {
    if (this.ipBoardPart.sign != null) {
      this.textLabel = StringHelper.join(
        [
          this.ipBoardPart.sign.textType != null
            ? this.ipBoardPart.sign.textType.label
            : null,
          !StringHelper.isEmpty(this.ipBoardPart.sign.textColors)
            ? 'Kleur tekst: ' + this.ipBoardPart.sign.textColors
            : null,
          !StringHelper.isEmpty(this.ipBoardPart.sign.backgroundColor)
            ? 'Kleur achtergrond: ' + this.ipBoardPart.sign.backgroundColor
            : null
        ],
        ' - '
      );
    } else {
      this.textLabel = null;
    }
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
    this.emitTextFilled.complete();
  }

  private initializeShowOtherSideField(): void {
    this.showOtherSideField = !StringHelper.isEmpty(
      this.ipBoardPart.otherCustomText
    );
  }

  customTextChanged(): void {
    this.emitTextFilled.next();
    this.save.emit();
  }

  showOtherSideFieldChanged(): void {
    if (!this.showOtherSideField) {
      this.ipBoardPart.otherCustomText = null;
      this.emitTextFilled.next();
      this.save.emit();
    }
  }

  otherCustomTextChanged(): void {
    this.emitTextFilled.next();
    this.save.emit();
  }

  private doEmitTextFilled(): void {
    this.projectDisplayObservableService
      .getIPBoardTextFilledSubscribable()
      .next(
        !(
          StringHelper.isEmpty(this.ipBoardPart.customText) &&
          StringHelper.isEmpty(this.ipBoardPart.otherCustomText) &&
          (this.ipBoard.otherSideBoardPart != null &&
            StringHelper.isEmpty(this.ipBoard.otherSideBoardPart.customText))
        )
      );
  }

  openAbbreviationSelectorModal(): void {
    this.modalService.openComponentInModal(
      IPBoardPartAbbreviationSelectorComponent,
      [{ key: 'ipBoardPart', value: this.ipBoardPart }],
      new ObservableHandlerPair(
        modalRef => modalRef.componentInstance.selectionChanged,
        (abbreviations: IPBoardPartAbbreviation[]) => {
          if (abbreviations != null) {
            this.ipBoardPart.abbreviations = abbreviations;
            this.save.emit();
          }
        }
      ),
      { minWidth: 750 }
    );
  }
}
